module.exports = __webpack_public_path__ + "img/bbd1d96d49e032c0fd671727998b9430.0cda12d3.png";